import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '#pplx/frontend/aether/components/Button/index.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
export function DictationSlotComponent({ isDisabled = false, isInitializing, isSupported, isTranscribing, onStartTranscription, onStopTranscription, startLabel, stopLabel, }) {
    if (!isSupported) {
        return null;
    }
    if (isTranscribing) {
        return (_jsx(Button, { "aria-label": stopLabel, icon: $icon('player-stop-filled'), onClick: onStopTranscription, rounded: true, size: "small", variant: "tonal" }));
    }
    return (_jsx(Button, { "aria-label": startLabel, disabled: isDisabled, icon: $icon('microphone'), isLoading: isInitializing, onClick: onStartTranscription, rounded: true, size: "small", variant: "text" }));
}
//# sourceMappingURL=DictationSlotComponent.js.map